﻿import React, { useState, useEffect } from 'react';
//Components
import AppPackageProducts from '../AppPackage/Subpages/AppPackageProducts';
import Button from '@mui/material/Button';
import LoadingIndicator from 'components/Global/loading-indicator/loading-indicator';
import CheckoutList from '../AppPackage/Subpages/CheckoutList';
import { StrikeThroughHeader } from 'Components/Headers/strikethrough-header/strikethrough-header';
import { MenuItem, Select, Paper } from '@mui/material';
//Utilities
import { useQuery } from '@tanstack/react-query';
import { useUser } from 'context/UserContext';
import useForm from '../../../AdminContentMgt/Components/useForm';
import {
  BrowserRouter as Router,
  Route,
  Link,
  Routes,
  Navigate,
  useNavigate,
  useLocation,
} from 'react-router-dom';
import {
  GetProductListAll,
  GetAgeList,
  GetServiceForms,
  SaveIsd,
  SaveCareer,
  GetAppPackageForms,
} from 'api/apppackage';
import { GetResponses, GetSourceOfFunds, GetDivisions } from 'api/referencedata';

export default function AppPackage() {
  let routePrefix = 'Applications';
  const location = useLocation();
  const navigate = useNavigate();
  const user = useUser();
  const urlParams = new URLSearchParams(window.location.search);
  const [productList, setProductList] = useState([]);
  const [currentProduct, setCurrentProduct] = useState('');
  const [overrideDivision, setOverrideDivision] = useState(null);
  const [division, setDivision] = useState(
    user.isHO == true ? 'CASG' : user.division
  );
  const [form, setForm] = useState(null);
  const [checkOutList, setCheckOutList] = useState([]);

  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    setErrors({ ...temp });
    if (fieldValues === values) return Object.values(temp).every((x) => x === '');
  };

  const { values, errors, setErrors, setValues, handleDataChange } = useForm(form, true, validate);

  const getYesNoDontKnowQuery = useQuery({
    queryKey: ['GetResponses'],
    queryFn: () => GetResponses()(),
  });
  const getFundingSourceQuery = useQuery({
    queryKey: ['GetSourceOfFunds'],
    queryFn: () => GetSourceOfFunds()(),
  });
  const getYesNoQuery = useQuery({
    queryKey: ['GetResponses'],
    queryFn: () => GetResponses()(),
  });
  const getDivisionsQuery = useQuery({
    queryKey: ['GetDivisions'],
    queryFn: () => GetDivisions()(),
  });
  const getAgeList = useQuery({
    queryKey: ['GetAgeList'],
    queryFn: () => GetAgeList()(),
  });
  const productListQuery = useQuery({
    queryKey: ['GetProductListAll'],
    queryFn: () => GetProductListAll()(),
  });
  const getServiceFormsQuery = useQuery({
    queryKey: ['GetServiceForms', currentProduct],
    queryFn: () =>
      GetServiceForms({
        ProductID: currentProduct,
        BLine: division == 'CASG' ? '1' : '2',
        UType: '1',
      })(),
    enabled: currentProduct !== '',
  });

  const getAppPackageQuery = useQuery({
    queryKey: ['GetAppPackage', values?.appId ?? '0'],
    queryFn: () => GetAppPackageForms({
      BusinessLine: division === 'CASG' ? 'CASG' : division === 'ISD' ? 'ISD' : 'NA',
      Product: productList.find(p => p.productID === values.product)?.productName ?? 'NA', AnnuityType: values.annuityType ?? 'NA', State: values.state ?? 'NA',
      FundSource: values.fundSource ?? 'NA', Existing: values.existing ?? 'NA', Replacement: values.replacement ?? 'NA',
      Exchange: values.exchange ?? 'NA', LapseSurrender: values.lapseSurrender ?? 'NA', Rollover: values.rollover ?? 'NA',
      Transfer: values.transfer ?? 'NA', FullyUnderwritten: values.fullyUnderWritten ?? 'NA',
      SurrenderCharges: values.surrenderCharges ?? 'NA',
    })(),
    enabled: false,
  });

  /*const saveCareerQuery = useQuery({
    queryKey: ['SaveCareer', values != null ? values.appId : '0'],
    queryFn: () => SaveCareer({ Form: values })(),
    enabled: false,
  });

  const saveIsdQuery = useQuery({
    queryKey: ['SaveIsd', values != null ? values.appId : '0'],
    queryFn: () => SaveIsd({ Form: values })(),
    enabled: false,
  });*/

  function checkLOB(iD3Code) {
    var isValid = user.LOB.find((o) => o.ProductCode == iD3Code);
    return isValid != null && isValid != undefined;
  }

  const [fastForms, setFASTForms] = useState([]);

  const ProductDropdown = () => {
    return (
      <div className="col" style={{ padding: '0 0 1em 0' }}>
        {productList != null && (
          <div className="row">
            <div>
              <div>{'Selected Product'}</div>
              <Select
                labelId="demo-simple-select-label"
                id="product-select"
                value={currentProduct}
                style={{ width: '20em' }}
                label={'Product'}
                onChange={(e) => {
                  setCurrentProduct(e.target.value);
                }}
              >
                {productList.map((product, index) => {
                  if (checkLOB(product.iD3Code))
                    return (
                      <MenuItem id={index} key={product.productID} value={product.productID}>
                        {product.productName}
                      </MenuItem>
                    );
                })}
              </Select>
            </div>
            {/*allow the home office user to override the division*/}
            {user.isHO === true && getDivisionsQuery.data != null && (
              <div style={{ padding: '0 1.5em 0 1.5em' }}>
                <div>{'Override Division'}</div>
                <Select
                  labelId="overrideDivision-demo-simple-select-label"
                  id="overrideDivision-select"
                  value={overrideDivision ?? ''}
                  onChange={(e) => {
                    setOverrideDivision(e.target.value);
                  }}
                  style={{ width: '20em' }}
                >
                  {getDivisionsQuery.data.map((d) => (
                    <MenuItem key={d.value} value={d.value}>
                      {d.text}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  useEffect(() => {
    if (productListQuery.data != null) {
      /* let tmpDivision = division;
      if (user.isHO == true) { tmpDivision = overrideDivision == 1 ? 'CASG' : 'ISD'; }
      if (tmpDivision == 'CASG') { //modify the list based on career
          for (var i = 0; i < filteredLst.length; i++) {
              var product = filteredLst[i];
              tmpLst.push(product);
          }
      }
      else if (tmpDivision == 'ISD') { //modify the list based on isd
          for (var i = 0; i < filteredLst.length; i++) {
              var product = filteredLst[i];
              if (product.productName == 'Generation Legacy' || product.productName == 'Silver Guard' || product.productName == 'Sing. Prem. Whole Life'
                  || product.productName == 'Term' || product.productName == 'Whole Life' || product.productName == 'iProvide (Level & 20 Pay)' || product.productName == 'iProvide (Single Pay)' )
                  tmpLst.push(product);
          }
        }*/

      setProductList(productListQuery.data.listValues.filter((o) => o.iD3Code != 'DISC'));
    }
  }, [productListQuery.data, overrideDivision]);

  useEffect(() => {
    if (getDivisionsQuery.data && overrideDivision === null) {
      setOverrideDivision(getDivisionsQuery.data[0].value);
    }
  }, [getDivisionsQuery.data]);

  useEffect(() => {
    if (user.isHO == true && overrideDivision !== null) {
      setDivision(
        urlParams.get('overrideDivision') == undefined
          ? getDivisionsQuery.data?.[0]?.value === overrideDivision
            ? 'CASG'
            : 'ISD'
          : urlParams.get('overrideDivision')
      );
    }
  }, [overrideDivision]);

  useEffect(() => {
    if (values != null) {
      setDivision(
        user.isHO == true && urlParams.get('overrideDivision') != undefined
          ? urlParams.get('overrideDivision')
          : user.division
      );
    }
  }, [values]);

  useEffect(() => {
    if (getServiceFormsQuery.isSuccess && getServiceFormsQuery.data) {
      HandleCreateForm(getServiceFormsQuery.data);
    }
  }, [getServiceFormsQuery.isSuccess, getServiceFormsQuery.data]);

  /*useEffect(() => {
    if (saveCareerQuery.isSuccess && saveCareerQuery.data) {
      handleDataChange('appId', saveCareerQuery.data);
      setFASTForms(saveCareerQuery.data.forms);
      navigate(
        `/${routePrefix}/AppPackage/Checkout/Checkoutlist?id=${saveCareerQuery.data.appID}&productid=${urlParams.get('productid')}&bline=1`,
        { state: { productValues: values } }
      );
    }
  }, [saveCareerQuery.isSuccess, saveCareerQuery.data]);

  useEffect(() => {
    if (saveIsdQuery.isSuccess && saveIsdQuery.data) {
      handleDataChange('appId', saveIsdQuery.data);
      setFASTForms(saveIsdQuery.data.forms);
      navigate(
        `/${routePrefix}/AppPackage/Checkout/Checkoutlist?id=${saveIsdQuery.data.appID}&productid=${urlParams.get('productid')}&bline=2`,
        { state: { productValues: values } }
      );
    }
  }, [saveIsdQuery.isSuccess, saveIsdQuery.data]);*/

  useEffect(() => {
    if (getAppPackageQuery.isSuccess && getAppPackageQuery.data) {
      const mappedForms = getAppPackageQuery.data
        .filter((f) => f.form != null)
        .map((f) => ({
          baseFormLocation: `AppForms/${f.form.formNumber}.pdf`,
          formDescription: f.form.formName,
          formId: f.form.formNumber,
          id: 0,
          isApplication: f.form.isApplication,
          numberOfCopies: f.numberOfCopies ?? 1,
          numberToOrder: 0,
          sequenceNumber: null
        }));
      const selectedMiscForms = (values.formList ?? [])
        .filter((f) => f.selected)
        .filter((f) => !mappedForms.some((m) => m.formId === f.formNumber))
        .map((f) => ({
          baseFormLocation: `AppForms/${f.formNumber}.pdf`,
          formDescription: f.formDescription,
          formId: f.formNumber,
          id: 0,
          isApplication: f.isApplication,
          numberOfCopies: 1,
          numberToOrder: 0,
          sequenceNumber: null
        }));
      setFASTForms([...mappedForms, ...selectedMiscForms]);
      const bline = division === 'CASG' ? 1 : 2;
      navigate(
        `/${routePrefix}/AppPackage/Checkout/Checkoutlist?id=0&productid=${urlParams.get('productid')}&bline=${bline}`,
        { state: { productValues: values } }
      );
    }
  }, [getAppPackageQuery.isSuccess, getAppPackageQuery.data]);

  {
    /*Handle Create New Form Based On Data*/
  }
  const HandleCreateForm = (data) => {
    //only add the fully underwritten param if these are met
    if (
      currentProduct == '17' ||
      currentProduct == '15' ||
      currentProduct == '16' ||
      currentProduct == '9' ||
      currentProduct == '7' ||
      currentProduct == '4' ||
      currentProduct == '2' ||
      currentProduct == '8' ||
      (division == 'CASG' &&
        (currentProduct == '13' ||
          currentProduct == '11' ||
          currentProduct == '12' ||
          currentProduct == '10' ||
          currentProduct == '14' ||
          currentProduct == '17'))
    ) {
      window.location.href =
        division == 'CASG'
          ? '/' +
            routePrefix +
            '/AppPackage/CareerPackage?productid=' +
            currentProduct +
            (user.isHO == true ? '&overrideDivision=' + division : '')
          : '/' +
            routePrefix +
            '/AppPackage/ISDPackage?productid=' +
            currentProduct +
            (user.isHO == true ? '&overrideDivision=' + division : '');
    } else {
      window.location.href =
        division == 'CASG'
          ? '/' +
            routePrefix +
            '/AppPackage/CareerPackage?productid=' +
            currentProduct +
            '&fullyunderwritten=' +
            (values != null ? values.fullyUnderWritten : 'true') +
            (user.isHO == true ? '&overrideDivision=' + division : '')
          : '/' +
            routePrefix +
            '/AppPackage/ISDPackage?productid=' +
            currentProduct +
            '&fullyunderwritten=' +
            (values != null ? values.fullyUnderWritten : 'true') +
            (user.isHO == true ? '&overrideDivision=' + division : '');
    }
  };

  const handleCheckOutList = (data) => {
    setCheckOutList(data);
  };

  const Save = (data) => {
    //update 1483 form if career and form exists
    for (var i = 0; i < data.formList.length; i++) {
      if (data.formList[i].formNumber == '7' && division == 'CASG')
        data.formList[i].questionText = 'You have an Attachment to Application (Form1483)';
    }

    //#TODO: Get situation ID after saving, then call the checkout, eliminates the need to send the situation id back up
    //#TODO: Make sure the url have the situation id -> make spinner on the button when loading
    //TODO: have a error page if the situation is invalid
    // if (division == 'CASG') saveCareerQuery.refetch();
    // else if (division == 'ISD') saveIsdQuery.refetch();

    getAppPackageQuery.refetch();
  };

  const IsLoading = () => {
    if (
      getYesNoDontKnowQuery.isPending ||
      getYesNoQuery.isPending ||
      getDivisionsQuery.isPending ||
      //   || getStateQuery.isPending
      // || getAnnuityQuery.isPending
      (currentProduct !== '' && getServiceFormsQuery.isPending) ||
      getFundingSourceQuery.isPending ||
      getAgeList.isPending 
     // saveCareerQuery.isFetching ||
     // saveIsdQuery.isFetching
    )
      return true;
    return false;
  };

  function checkUserPermissionsToProductID() {
    let pID = urlParams.get('productid');

    if (pID != null) {
      let product = productList.find((o) => o.productID == pID);

      if (product != null) {
        return checkLOB(product.iD3Code);
      }
    }

    return true;
  }

  if (!checkUserPermissionsToProductID()) {
    return <Navigate to={`/Error/AccessDenied?requested=${location.pathname}`} />;
  }

  if (IsLoading()) return <LoadingIndicator />;

  return (
    <div>
      <StrikeThroughHeader>App Package</StrikeThroughHeader>
      <Paper square style={{ padding: '1em' }}>
        <div style={{ textAlign: 'right' }}>
          <Button
            size="small"
            variant="contained"
            id="btnStartOver"
            name="StartOver"
            className="btn btn-primary"
          >
            <Link style={{ color: 'white' }} to={'/' + routePrefix + '/AppPackage'}>
              Start Over
            </Link>
          </Button>
        </div>
        <Routes>
          <Route
            path={'Checkout/*'}
            element={<CheckoutList handleCheckOutList={handleCheckOutList} fastForms={fastForms} />}
          />
          <Route
            path="CareerPackage/*"
            element={
              <div>
                <AppPackageProducts setAppPackageValues={setValues} />
                <div style={{ textAlign: 'center' }}>
                  <Button
                    style={{ color: 'white' }}
                    size="small"
                    variant="contained"
                    className="btn btn-primary"
                    id="btnCreateChecklist"
                    onClick={() => {
                      Save(values);
                    }}
                  >
                    Create Checklist{' '}
                  </Button>
                </div>
              </div>
            }
          />
          <Route
            path="ISDPackage/*"
            element={
              <div>
                <AppPackageProducts setAppPackageValues={setValues} />
                <div style={{ textAlign: 'center' }}>
                  <button
                    style={{ color: 'white' }}
                    type="button"
                    className="btn btn-primary"
                    id="btnCreateChecklist"
                    onClick={() => {
                      Save(values);
                    }}
                  >
                    Create Checklist{' '}
                  </button>
                </div>
              </div>
            }
          />
          <Route path={'/'} element={<ProductDropdown />} />
          <Route path={'/*'} element={<ProductDropdown />} />
        </Routes>
      </Paper>
    </div>
  );
}
